module.exports = __webpack_public_path__ + "img/twitterLoginImg.fead7c28.svg";